import React from "react";
import PropTypes from "prop-types";
import Components from "./extensions/autocomplete/index";
import {
  classes,
  MuiCreatable as Creatable,
  autocompleteCustomStyles
} from "../styles/autocompleteCreatable";
import { isNullOrUndefined } from "../../../functions/util";

const AutoCompleteCreatable = ({
  id,
  variant,
  label,
  name,
  displayErrors,
  errors,
  disabled,
  prevValue,
  value,
  options,
  textFieldClassName,
  InputProps,
  formHelperTextProps,
  inputLabelProps,
  helperText,
  placeholder,
  onChange,
  isMulti
}) => {
  const handleChange = val => {
    if (typeof onChange === "function") {
      if (val && val.constructor === Array) {
        const newVal = val ? val.map(x => x.value) : null;
        onChange(newVal);
      } else {
        onChange(val ? val.value : null);
      }
    }
  };

  const filteredOptions = options.filter(item => {
    if (isNullOrUndefined(item.enabled)) {
      return true;
    }
    if (!isNullOrUndefined(prevValue) && item.key === prevValue) {
      return true;
    }
    return item.enabled;
  });

  const suggestions = filteredOptions.map(suggestion => ({
    value: suggestion.key,
    label: suggestion.text
  }));

  const errorText = errors[0];
  const isValid = errors.length === 0;

  let valueObject = null;
  if (value && value.constructor === Array) {
    valueObject = [];
    value.forEach(x => {
      let val = suggestions.filter(s => s.value === x.key);
      if (val === undefined || val.length === 0) {
        val = [{ value: x.text, label: x.text }];
      }
      valueObject = valueObject.concat(val);
    });
  } else {
    valueObject = suggestions.filter(s => s.value === value)[0] || null;
  }

  return (
    <Creatable
      id={id}
      variant={variant}
      label={label}
      name={name}
      options={suggestions}
      components={Components}
      value={valueObject}
      onChange={handleChange}
      errorText={errorText}
      isValid={isValid}
      displayErrors={displayErrors}
      isSearchable
      isClearable
      isDisabled={disabled}
      placeholder={placeholder}
      styles={autocompleteCustomStyles}
      classes={classes}
      menuPortalTarget={document.body}
      textFieldClassName={textFieldClassName}
      isMulti={isMulti}
      InputProps={InputProps}
      formHelperTextProps={formHelperTextProps}
      inputLabelProps={inputLabelProps}
      helperText={helperText}
    />
  );
};

AutoCompleteCreatable.propTypes = {
  id: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["standard", "outlined"]),
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  prevValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.bool
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.bool
  ]),
  displayErrors: PropTypes.bool,
  error: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ]),
      text: PropTypes.string
    })
  ),
  onChange: PropTypes.func,
  placeholder: PropTypes.string
};

AutoCompleteCreatable.defaultProps = {
  variant: "outlined",
  options: [],
  errors: [],
  displayErrors: false,
  disabled: false,
  label: undefined,
  placeholder: "",
  isMulti: false
};

export default AutoCompleteCreatable;
